import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { FooterContentComponent } from './footer-content/footer-content.component';
import { FooterHeaderComponent } from './footer-header/footer-header.component';
import { FooterBottomComponent } from './footer-bottom/footer-bottom.component';
import { MenuService } from '../../services/menu.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { YesCategory } from '../megamenu/megamenu.types';
import { LanguagePopupComponent } from '../language-popup/language-popup.component';
import { TranslocoService } from '@jsverse/transloco';
import { PromoDialogComponent } from '../promo-dialog/promo-dialog.component';

declare const Cookiebot:
  | {
      renew: () => void;
    }
  | undefined;

@Component({
  selector: 'app-footer',
  imports: [
    FooterContentComponent,
    FooterHeaderComponent,
    FooterBottomComponent,
    LanguagePopupComponent,
    PromoDialogComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private readonly t = inject(TranslocoService);
  private readonly menu = inject(MenuService);
  private _categories = toSignal(
    this.menu.getFooterNavigation().pipe(
      map((categories) => {
        const mapped = { main: [] as YesCategory[], bottom: [] as YesCategory[] };
        categories.forEach((c) => {
          if (c.name === 'below footer') {
            mapped.bottom.push(...c.children);
          } else {
            mapped.main.push(c);
          }
        });

        const label = this.t.translate('Cookie settings');

        if (mapped.main[mapped.main.length - 1].children.slice(-1)[0].label !== label) {
          mapped.main[mapped.main.length - 1].children.push({
            label: this.t.translate('Cookie settings'),
            name: 'Cookie settings',
            action: () => Cookiebot?.renew(),
            children: [],
            url: '',
            queryParams: {},
            carousel: [],
          });
        }

        return mapped;
      }),
    ),
  );

  categories = computed(() => this._categories()?.main ?? []);
  bottomCategories = computed(() => this._categories()?.bottom ?? []);
}
